import yellowHomeImg from "../../../assets-user/yellowHome.png";
import pinkHomeImg from "../../../assets-user/pinkHome.png";
import greenHomeImg from "../../../assets-user/greenHome.png";
import blueHomeImg from "../../../assets-user/blueHome.png";
// import upArrowImg from "../../../assets-user/upArrow.png";
// import downArrowImg from "../../../assets-user/downArrow.png";

const HowItWorks = () => {
  const steps = [
    {
      step: "STEP 1",
      title: "Browse Properties",
      description:
        "Explore a wide range of verified listings across locations.",
      bgColor: "bg-[#FFF9E6]",
      borderColor: "border-[#E6C200]",
      icon: yellowHomeImg,
      // arrow: downArrowImg,
    },
    {
      step: "STEP 2",
      title: "Use Smart Filters",
      description:
        "Refine your search by budget, type, location, and amenities.",
      bgColor: "bg-[#FFEFF7]",
      borderColor: "border-[#FF77B7]",
      icon: pinkHomeImg,
      // // arrow: upArrowImg,
    },
    {
      step: "STEP 3",
      title: "Connect Directly",
      description: "Contact owners or builders instantly, without middlemen.",
      bgColor: "bg-[#E7FFEE]",
      borderColor: "border-[#38D87F]",
      icon: greenHomeImg,
      // // arrow: downArrowImg,
    },
    {
      step: "STEP 4",
      title: "Close the Deal",
      description: "Finalize your property with transparency and confidence.",
      bgColor: "bg-[#F2F0FF]",
      borderColor: "border-[#8A77FF]",
      icon: blueHomeImg,
      // arrow: null,
    },
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-10 bg-[#F9FBFF] relative">
      {/* Heading Section */}
      <div className="text-left mb-6 lg:mb-8">
        <h1 className="font-[Poppins] font-medium text-[24px] sm:text-[28px] md:text-[32px] leading-[150%] tracking-[0.01em] text-[#031722] mb-1">
          How it Works?
        </h1>
        <p className="text-[#666666] text-base lg:text-lg w-full md:w-[63%] lg:w-[55%] xl:w-[35%] leading-relaxed">
          Buying or selling should be simple, transparent, and stress-free. At
          LeadBook, we've made the entire process easy to follow—just four quick
          steps to find your perfect property.
        </p>
      </div>

      {/* Steps Section */}
      <div className="relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((item, index) => (
            <div key={index} className="relative">
              {/* Step Card */}
              <div
                className={`relative border-t-2 ${item.borderColor} rounded-2xl p-6 h-full flex flex-col bg-white shadow-sm hover:shadow-lg transition-all duration-300`}
              >
                {/* Step Number */}
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-gray-400">
                    {item.step}
                  </h2>
                  {/* Icon Container */}
                </div>

                {/* Content Box */}
                <div
                  className={`${item.bgColor} rounded-2xl p-5 shadow-inner flex-1`}
                >
                  <div
                    className={`w-12 h-12 rounded-xl ${item.bgColor} flex items-center justify-center`}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="w-10 h-10 object-contain"
                    />
                  </div>
                  <h3 className="text-[#2B2B2B] text-lg font-semibold mt-2 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-[#666666] text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>

              {/* Arrow between steps - hidden on mobile, shown on desktop */}
              {item.arrow && (
                <div className="hidden lg:block absolute -right-4 top-1/2 transform -translate-y-1/2 z-10">
                  <img
                    src={item.arrow}
                    alt="arrow"
                    className="w-8 h-8 object-contain"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
